<section class="widget-page">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0 page-title" i18n>Request a Review Widget</h6>
      <app-page-help articleId="-" videoId="-"></app-page-help>
      <ul class="internal-module-switcher ml-3">
        <li
          class="module-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          matTooltip="Dashboard"
          i18n-matTooltip
        >
          <a routerLink="/reviews">
            <i class="cs-icon cs-icon-dashboard2 text-xl"></i>
          </a>
        </li>
        <li class="module-item" routerLinkActive="active" matTooltip="Reviews" i18n-matTooltip>
          <a routerLink="/reviews/list">
            <i class="cs-icon cs-icon-chat-star2 text-xl"></i>
          </a>
        </li>
        <li class="module-item" routerLinkActive="active" matTooltip="Widget" i18n-matTooltip>
          <a routerLink="/reviews/widget">
            <i class="cs-icon cs-icon-cubes text-xl"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="flex-fill"></div>
  </div>
  <div class="main-content">
    <div class="details-box">
      <div class="box-body">
        <div class="row">
          <div class="col-lg-6 col-xl-5">
            <div class="widget-holder p-3 container-box">
              <div class="alert alert-secondary-info">
                <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                <div class="aler-content" i18n>
                  Note: Review widgets allow you to collect guest reviews on any website seamlessly. Simply copy and
                  paste the widget code to your site, and start showcasing valuable feedback from your guests.
                </div>
              </div>

              <form [formGroup]="form">
                <app-rental-select
                  [multiple]="false"
                  [ctrl]="form.get('rental')"
                  placeholder="Rental"
                  i18n-placeholder
                ></app-rental-select>

                <h6 class="text-light text-uppercase text-semi-bold mb-2" i18n>Button Style</h6>
                <div class="row">
                  <div class="col-sm-3">
                    <mat-form-field2 class="mat-block">
                      <input
                        matInput
                        [value]="form.get('color').value"
                        i18n-placeholder
                        placeholder="Font Color"
                        [colorPicker]="form.get('color').value"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'bottom'"
                        (colorPickerChange)="onColorSelected('color', $event)"
                        required
                      />
                      <mat-icon
                        matSuffix
                        fontSet="fas"
                        fontIcon="fa-circle"
                        class="color-picker-value-indicator"
                        [style.color]="form.get('color').value"
                      ></mat-icon>
                    </mat-form-field2>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field2 class="mat-block">
                      <input
                        matInput
                        i18n-placeholder
                        [value]="form.get('backgroundColor').value"
                        placeholder="Background Color"
                        [colorPicker]="form.get('backgroundColor').value"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'bottom'"
                        (colorPickerChange)="onColorSelected('backgroundColor', $event)"
                        required
                      />
                      <mat-icon
                        matSuffix
                        fontSet="fas"
                        fontIcon="fa-circle"
                        class="color-picker-value-indicator"
                        [style.color]="form.get('backgroundColor').value"
                      ></mat-icon>
                    </mat-form-field2>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field2 class="mat-block">
                      <input
                        matInput
                        [value]="form.get('borderColor').value"
                        i18n-placeholder
                        placeholder="Border Color"
                        [colorPicker]="form.get('borderColor').value"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'bottom'"
                        (colorPickerChange)="onColorSelected('borderColor', $event)"
                        required
                      />
                      <mat-icon
                        matSuffix
                        fontSet="fas"
                        fontIcon="fa-circle"
                        class="color-picker-value-indicator"
                        [style.color]="form.get('borderColor').value"
                      ></mat-icon>
                    </mat-form-field2>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field2 class="mat-block">
                      <input
                        type="number"
                        matInput
                        required
                        placeholder="Border Width (px)"
                        i18n-placeholder
                        formControlName="borderWidth"
                      />
                    </mat-form-field2>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field2 class="mat-block">
                      <mat-select placeholder="Border Radius" formControlName="borderRadius" required>
                        <mat-option *ngFor="let size of borderRadiusOpts" [value]="size">
                          {{ size }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field2>
                  </div>
                </div>

                <div class="widget-box">
                  <div class="tab-content">
                    <div class="tab-pane fade show active">
                      <div class="alert alert-dark">
                        <p class="widget-code" [innerText]="widgetCode"></p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="">
                  <button
                    type="button"
                    class="btn btn-secondary-info"
                    [disabled]="!widgetCode"
                    ngxClipboard
                    [cbContent]="widgetCode"
                    (cbOnSuccess)="onCopied()"
                  >
                    <span class="cs-icon cs-icon-copy"></span>
                    <ng-container i18n>Copy Code</ng-container>
                  </button>

                  <div class="text-sm text-light mt-3" i18n>
                    Copy and paste the desired widget code onto your website.
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7">
            <div class="widget-preview d-flex align-items-center flex-column h-100 p-3">
              <h5 class="title text-light" i18n>Widget Preview</h5>

              <div class="preview-box flex-fill w-100">
                <iframe
                  *ngIf="trustedWidgetCode"
                  [srcdoc]="trustedWidgetCode"
                  frameborder="0"
                  class="w-100 h-100"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
